@if (showBanner()) {
<!-- Spacer to offset fixed banner -->
<div class="h-11"></div>

<!-- Fixed banner -->
<div [ngClass]="bannerColorClass()"
  class="fixed top-0 left-0 right-0 z-[10000] text-white shadow-lg">
  <div class="mx-auto px-4 sm:px-6 lg:px-8 py-2">
    <div class="flex items-center justify-between gap-3">
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <div class="flex-shrink-0">
          @if (!isUrgent()) {
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd" />
          </svg>
          } @else {
          <svg class="w-5 h-5 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd" />
          </svg>
          }
        </div>

        <p class="text-sm font-medium leading-snug truncate">
          @if (isUrgent()) {
            ¡Acción inmediata requerida!
          } @else {
            Ajuste de membresía requerido
          }
          <span class="font-normal opacity-90">&mdash;
            Tu plan permite hasta {{ gracePeriodStatus()?.paidProfessionalsCount }} profesional(es),
            pero tienes {{ gracePeriodStatus()?.activeProfessionalsCount }} activo(s).
            Tienes {{ gracePeriodStatus()?.daysRemaining }} día(s) para regularizar
            (pagar por {{ gracePeriodStatus()?.unpaidProfessionalsCount }} profesional(es) adicional(es)
            o reducir tu equipo).
            Monto pendiente: ${{ gracePeriodStatus()?.unpaidAmount | number:'1.0-0' }}.
            Fecha límite: {{ getFormattedDate() }}
          </span>
        </p>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0">
        <button type="button" (click)="onPayNow()"
          class="px-4 py-1.5 bg-white/95 hover:bg-white font-semibold rounded-md text-sm transition-colors duration-200 shadow-sm"
          [ngClass]="isUrgent() ? 'text-red-600' : 'text-amber-600'">
          Pagar ahora
        </button>
        <button type="button" (click)="onDismiss()"
          class="p-1.5 hover:bg-white/20 rounded-md transition-colors duration-200" aria-label="Cerrar">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
}

